import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import TimeAgo from './TimeAgo';
import LikeComment from './LikeComment';
import Comments from './Comments';
import secureLocalStorage from 'react-secure-storage';
import renderHTML from './RenderHtml';
import linkifyHashtags from './linkifyHashtags';
import { FaPlus } from 'react-icons/fa';
import { IoClose } from 'react-icons/io5';
import SinglePost from '../components/SinglePost';
import axios from 'axios';
import PdfViewer from './PdfViewer';

const GroupPostDocCard = ({ src, title, file }) => {
    const [pdfPages, setPdfPages] = useState(0);
    const docTitle = title && title !== 'posted an update' ? title : null;
    return (
        <div className="post-doc-card">
            <div className="post-doc-card-header">
                <i className="fas fa-file-alt post-doc-card-file-icon" />
                <div className="post-doc-card-meta">
                    {docTitle && <span className="post-doc-card-title">{docTitle}</span>}
                    {pdfPages > 0 && <span className="post-doc-card-pages">{pdfPages} {pdfPages === 1 ? 'page' : 'pages'}</span>}
                </div>
                <a
                    href={`https://buzzinguniverse.com/backend/${file}`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                    className="post-doc-card-download"
                    onClick={e => e.stopPropagation()}
                    title="Download PDF"
                >
                    <i className="fas fa-download" />
                </a>
            </div>
            <PdfViewer src={src} onLoad={setPdfPages} />
        </div>
    );
};

const getPostTextStyle = (details) => {
    if (!details || details === 'null') return {};
    const text = details.replace(/<[^>]*>/g, '').trim();
    const len = text.length;
    if (len <= 40)  return { fontSize: '30px', fontWeight: '600', lineHeight: '1.3' };
    if (len <= 100) return { fontSize: '22px', fontWeight: '500', lineHeight: '1.4' };
    if (len <= 200) return { fontSize: '18px', lineHeight: '1.5' };
    return { fontSize: '15px', lineHeight: '1.6' };
};
const formatDateTime = (date) =>
    new Date(date).toLocaleString(undefined, {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    });

const GroupPost = ({ postsN, usrAuth }) => {
    const [loading, setLoading] = useState(true);
    const [imageLoaded, setImageLoaded] = useState(false);
    const [single_Post, setSinlgePost] = useState(null);
    const [posts, setPosts] = useState(postsN);
    const navigate = useNavigate();
    const postCardRef = useRef(null);
    const auth = JSON.parse(secureLocalStorage.getItem('auth_data'));

    const handleNextPost = () => {
        if (!single_Post) return;
        const currentIndex = posts.findIndex(p => p.post_data.id === single_Post.post_data.id);
        if (currentIndex < posts.length - 1) {
            setSinlgePost(posts[currentIndex + 1]);
        }
    };

    const handlePrevPost = () => {
        if (!single_Post) return;
        const currentIndex = posts.findIndex(p => p.post_data.id === single_Post.post_data.id);
        if (currentIndex > 0) {
            setSinlgePost(posts[currentIndex - 1]);
        }
    };

    const post = posts[0];

    const isValidUrl = (url) =>
        url !== "https://buzzinguniverse.com/backend/" && url;

    useEffect(() => {
        if (posts) {
            setTimeout(() => setLoading(false), 1000);
        }
    }, [posts]);

    useEffect(() => {
        const container = postCardRef.current;
        if (!container) return;

        const handleClick = (e) => {
            const mention = e.target.closest('[nav_id]');
            if (mention) {
                const type = mention.getAttribute('mention_type');
                const id = mention.getAttribute('nav_id');
                if (type === 'group' || type === 'company') {
                    const name = mention.getAttribute('nav_name') || 'page';
                    navigate(`/company/${id}/${name}`);
                } else {
                    navigate(`/member/${id}/profile`);
                }
                return;
            }
            const hashtag = e.target.closest('a.post-hashtag');
            if (hashtag) {
                e.preventDefault();
                navigate(`/hashtag/${hashtag.getAttribute('data-tag')}`);
            }
        };

        container.addEventListener('click', handleClick);
        return () => container.removeEventListener('click', handleClick);
    }, [navigate]);

    const handleImageLoad = () => setImageLoaded(true);

    const GetPoost = async () => {
        const currentIndex = posts.findIndex(p => p.post_data.id === single_Post.post_data.id);
        setPosts(prevItems => {
            const newItems = [...prevItems];
            newItems[currentIndex] = single_Post;
            console.log(newItems)
            return newItems;
        });
    }

    const deletePost = async (e, postId) => {
        e.stopPropagation();
        if (!window.confirm('Are you sure you want to delete this image?')) return;

        try {
            const response = await axios.post('https://buzzinguniverse.com/backend/api/delete/post', {
                post_id: postId,
                user_id: auth?.id
            });

            if (response.data.code === 200) {
                setPosts(prevPosts => prevPosts.filter(p => p.post_data.id !== postId));
            } else {
                alert(response.data.message || 'Failed to delete image');
            }
        } catch (error) {
            console.error('Error deleting post:', error);
            alert(error.response?.data?.message || 'Failed to delete image. Please try again.');
        }
    }

    if (loading) {
        return (
            <div className="skeleton">
                <div className="header">
                    <div className="profile-pic"></div>
                    <div>
                        <div className="text"></div>
                        <div className="timestamp"></div>
                    </div>
                </div>
                <div className="image"></div>
            </div>
        );
    }

    return (
        <div className="personal_des_box activity-all-memeber-boxs" ref={postCardRef}>
            <ul>
                <li>
                    <Link to={`/member/${post.post_data.user.id}/profile`}>
                        <img
                            src={
                                isValidUrl(post.post_data.user.photo)
                                    ? `https://buzzinguniverse.com/backend/${post.post_data.user.photo}`
                                    : '/images/default.png'
                            }
                            alt="img"
                        />
                    </Link>
                </li>
                <li>
                    <Link to={`/member/${post.post_data.user.id}/profile`}>
                        {post.post_data.user.first_name} {post.post_data.user.last_name}
                    </Link>
                </li>
                <li>
                    <strong>{formatDateTime(post.post_data.created_at)}</strong>
                </li>
            </ul>

            {post.post_data.details && <p className="post-text-dynamic" style={getPostTextStyle(post.post_data.details)}>{renderHTML(linkifyHashtags(post.post_data.details))}</p>}

            <div className={`postGrid postGrid--count-${Math.min(posts.length, 6)}`}>
                {posts.slice(0, 6).map((pst, idx) => {
                    const fileUrl = `https://buzzinguniverse.com/backend/${pst.post_data.file}`;
                    const isLastVisible = idx === 5 && posts.length > 6;
                    const count = Math.min(posts.length, 6);

                    // Determine grid position class for special layouts
                    let positionClass = '';
                    if (count === 3) {
                        positionClass = idx === 0 ? 'postGrid__item--featured' : 'postGrid__item--small';
                    } else if (count === 5) {
                        positionClass = idx < 2 ? 'postGrid__item--top' : 'postGrid__item--bottom';
                    }

                    return (
                        <div
                            className={`postGrid__item ${positionClass}`}
                            key={pst.id || idx}
                            onClick={() => setSinlgePost(pst)}
                        >
                            <div className="postGrid__media">
                                {!imageLoaded && <div className="postGrid__skeleton"></div>}

                                {auth?.id === post.post_data.user.id && posts.length > 1 && (
                                    <button
                                        className="postGrid__delete"
                                        onClick={(e) => deletePost(e, pst.post_data.id)}
                                        title="Delete this image"
                                    >
                                        <IoClose size={18} />
                                    </button>
                                )}

                                {['jpg', 'png', 'gif', 'jpeg', 'webp'].includes(pst.post_data.file_type) && (
                                    <img
                                        src={fileUrl}
                                        alt="img"
                                        onLoad={handleImageLoad}
                                        style={{ opacity: imageLoaded ? 1 : 0 }}
                                    />
                                )}

                                {['mp4', 'mov', 'webm'].includes(pst.post_data.file_type) && (
                                    <video
                                        src={fileUrl}
                                        onLoadedData={handleImageLoad}
                                        style={{ opacity: imageLoaded ? 1 : 0 }}
                                    />
                                )}

                                {['mp3', 'wav', 'ogg'].includes(pst.post_data.file_type) && (
                                    <audio
                                        src={fileUrl}
                                        onLoadedData={handleImageLoad}
                                        style={{ opacity: imageLoaded ? 1 : 0 }}
                                        controls
                                    />
                                )}

                                {pst.post_data.file_type === 'pdf' && (
                                    <GroupPostDocCard
                                        src={fileUrl}
                                        title={pst.post_data.title}
                                        file={pst.post_data.file}
                                    />
                                )}

                                {isLastVisible && (
                                    <div className="postGrid__overlay">
                                        <FaPlus className="postGrid__overlayIcon" />
                                        <span>{posts.length - 6}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>

            {auth && <LikeComment post={post} allPostIds={posts.map(p => p.post_data.id)} />}
            <div className="commentScroll1">
                <Comments post={post} auth={auth} loadmore={true} />
            </div>

            {single_Post && (
                <SinglePost
                    setSinlgePost={setSinlgePost}
                    auth={auth}
                    post={single_Post}
                    onNext={handleNextPost}
                    onPrev={handlePrevPost}
                    GetPoost={GetPoost}
                />
            )}
        </div>
    );
};

export default GroupPost;
